var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25.2631579px",
    height: "30px",
    viewBox: "0 0 25.2631579 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u56FE\u7247") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.231,0 L25.263,6.336 L25.2631579,27.45408 C25.2631579,28.8601528 24.1233107,30 22.7172379,30 L2.54592,30 C1.13984721,30 6.16283464e-16,28.8601528 0,27.45408 L0,2.54592 C-1.72194254e-16,1.13984721 1.13984721,2.58291381e-16 2.54592,0 L19.231,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FD774A",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FDA182",
    mask: "url(#mask-2)",
    x: 18.9473684,
    y: -5.17241379,
    width: 9.47368421,
    height: 11.3793103,
    rx: 1.27296
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.4845735,21.4285714 L8.09650902,14.7981008 L11.6075735,17.8268571 L15.2706309,11.1428571 L20.907441,21.4285714 L3.4845735,21.4285714 Z",
    id: "\\u5408\\u5E76\\u5F62\\u72B6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#FFFFFF",
    cx: 7.84029038,
    cy: 11.1428571,
    rx: 1.74228675,
    ry: 1.71428571
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.a3e930fe63964632d239c140cc85cbe9.svg";
export { ForwardRef as ReactComponent };